export const textInputDark = {
  borderColor: 'white',
  borderStyle: 'solid',
  color: 'white',
  paddingLeft: 'm',
  paddingRight: 'm',
  inputTextStyle: {
    fontSize: 'm',
    color: 'white',
  },
  placeholderPropsStyle: {
    color: 'white',
    paddingLeft: 'm',
    paddingRight: 'm',
  },
  variants: {
    underline: {
      borderColor: 'grey/dark',
      borderBottomWidth: 1,
      borderLeftWidth: 0,
      borderRightWidth: 0,
      borderTopWidth: 0,
    },
    primary: {
      borderColor: 'primary',
    },
    secondary: {
      borderColor: 'light',
    },
    rounded: {
      borderColor: 'grey/dark',
      borderWidth: 'xs',
      borderRadius: 'round',
    },
  },
};
